import { styled, TableCell } from '@mui/material'

const TableCellNoWrap = styled(TableCell)({
  flexShrink: 0,
  whiteSpace: 'nowrap',
  width: '1px',
})

export default TableCellNoWrap
